<template>
  <router-link v-if="allowed" class="tab-link" :to="to">
    <slot />
  </router-link>
  <NeedSub v-else class="lock" @close="$emit('close')">
    <span class="tab-link nav-tab-lock">
      <slot />
      <LockIcon class="nav-tab-lock__icon" />
    </span>
  </NeedSub>
</template>

<script setup>
import { computed, defineEmits } from "vue";
import { useStore } from "vuex";
import NeedSub from "./modal/NeedSub.vue";
import LockIcon from "./common/icons/Lock.vue";

// Nav-вкладка с гейтингом по праву: если доступа нет — показывает замок
// в один ряд с названием (сразу после текста) и по клику открывает модалку.
defineEmits(["close"]);

const props = defineProps({
  permission: {
    type: String,
    required: true,
  },
  to: {
    type: String,
    required: true,
  },
});

const store = useStore();
const allowed = computed(() => store.getters.hasPermission(props.permission));
</script>

<style lang="scss" scoped>
.tab-link {
  position: relative;
  height: 100%;
  padding: 8px 16px;
  color: var(--font-color);
  border-bottom: 3px solid transparent;
  transition: all 0.2s;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 16px;
  line-height: 19.84px;
  letter-spacing: 2px;

  &.router-link-active {
    color: var(--brand-color);
  }
}

// локнутый таб: обычный inline-span (как остальные табы) → одинаковая высота.
// это span, а не ссылка — клик всплывает на обёртку NeedSub → модалка
.nav-tab-lock {
  cursor: pointer;
  white-space: nowrap;
}
.nav-tab-lock__icon {
  font-size: 1.05em; // замок крупнее, чем в фильтрах
  margin-left: 0.35em;
  vertical-align: -0.15em;
  color: var(--font-color);
}
</style>
